module.exports = __webpack_public_path__ + "static/media/bar-chart-reload.f623468b.webp";